let lenisInstance = null;

export const setLenis = (l) => {
  lenisInstance = l;
};

export const scrollToId = (target) => {
  if (lenisInstance) {
    lenisInstance.scrollTo(target, { duration: 1.6, offset: -70 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
